import {Injectable} from '@angular/core';
import {
    DeductionsDto,
    EarnedIncome,
    NewDirectTax,
    TaxDeduction,
    TaxRelief,
    TaxWithheld,
    UnEarnedIncome
} from "../../models/direct-tax.model";

@Injectable({
  providedIn: 'root'
})
export class TaxCalculatorService {

  private first_300000_7percent: number = 0.0;
  private first_300000_7percents: number = 0.0;
  private next_300000_11percent: number = 0.0;
  private next_300000_11percents: number = 0.0;
  private first_500000_15percent: number = 0.0;
  private first_500000_15percents: number = 0.0;
  private next_500000_19percent: number = 0.0;
  private next_500000_19percents: number = 0.0;
  private next_1600000_21percent: number = 0.0;
  private next_1600000_21percents: number = 0.0;
  private above_3200000_24percent: number = 0.0;
  private above_3200000_24percents: number = 0.0;

  private chargeableIncome: number = 0.0;
  private grossincome: number = 0.0;
  private relief: number = 0.0;
  private duty: number = 0.0;
  private NTP: number = 0.0;
  private taxPayablePerAnnum: number = 0.0;
  private TP: number = 0.0;


  private first_2m_15percent: number = 0.0;
  private first_9m_18percent: number = 0.0;
  private first_13m_21percent: number = 0.0
    private first_25m_23percent: number = 0.0;
  private above_50m_25percent: number = 0.0;


  constructor() { }

    public calculateTaxToIncome(income: number): NewDirectTax {

    const tax = Number(income);

      if (income > 21000) {
        this.first_300000_7percent = (21000 * 100) / 7;
        income -= 21000;
        this.first_300000_7percents = 21000;
        if (income> 33000) {
          this.next_300000_11percent = (33000 * 100) / 11;
          income -= 33000;
          this.next_300000_11percents = 33000;
          if (income > 75000) {
            this.first_500000_15percent = (75000 * 100) / 15;
            income -= 75000;
            this.first_500000_15percents = 75000;
            if (income > 95000) {
              this.next_500000_19percent = (95000 * 100) / 19;
              income -= 95000;
              this.next_500000_19percents = 95000;
              if (income > 336000) {
                this.next_1600000_21percent = (336000 * 100) / 21;
                income -= 336000;
                this.next_1600000_21percents = 336000;
                if (income > 0.0) {
                  this.above_3200000_24percent = (income * 100) / 24;
                  this.above_3200000_24percents = income;
                }
              } else {
                this.next_1600000_21percent = (income * 100) / 21;
                this.next_1600000_21percents = income;
              }
            } else {
              this.next_500000_19percent = (income * 100) / 19;
              this.next_500000_19percents = income;
            }
          } else {
            this.first_500000_15percent = (income* 100) / 15;
            this.first_500000_15percents = income;
          }
        } else {
          this.next_300000_11percent = (income * 100) / 11;
          this.next_300000_11percents = income;
        }
      } else {
        this.first_300000_7percent = (income * 100) / 7;
        this.first_300000_7percents = income;
      }

      this.chargeableIncome =
          this.first_300000_7percent +
          this.next_300000_11percent +
          this.first_500000_15percent +
          this.next_500000_19percent +
          this.next_1600000_21percent +
          this.above_3200000_24percent;

      if (tax < 3584000) {
        this.grossincome = (this.chargeableIncome + 200000) / 0.8;
      } else {
        this.grossincome = this.chargeableIncome / 0.79;
      }

      const higher = 0.01 * this.grossincome;

      if (higher > 200000) {
        this.relief = this.grossincome * 0.2 + higher;
      } else {
        this.relief = this.grossincome * 0.2 + 200000;
      }

      this.duty = this.getStampDuty(tax);

        this.NTP = Number(tax) + 500 + this.duty;


    const result: NewDirectTax = {
        first300: this.first_300000_7percents,
        second300: this.next_300000_11percents,
        third500: this.first_500000_15percents,
        fourth500: this.next_500000_19percents,
        fift1600: this.next_1600000_21percents,
        above1600: this.above_3200000_24percents,
        totalChargeableIncome: this.chargeableIncome,
        totalConsolidatedRelief: this.relief,
        totalIncome: this.grossincome,
        totalTaxDue: tax,
        totalTaxDeducted: 0.0,
        totalTaxPayable: this.NTP,
        stampDuty: this.duty,
        developmentLevy: 500,
        witheldTax: 0,
      statutoryIncome: 0
    }

    return result;
    }

  public calculateIncomeToTax(income: number): NewDirectTax {

    this.grossincome = income;

    const higher = 0.01 * this.grossincome;

    if (higher > 200000) {
      this.relief = this.grossincome * 0.2 + higher;
    } else {
      this.relief = this.grossincome * 0.2 + 200000;
    }

    this.chargeableIncome = this.grossincome - this.relief;

    var temp = this.chargeableIncome,
        _300k = 300000.0,
        _500k = 500000.0,
        _1600k = 1600000.0,
        _3200k = 1600000.0;

    this.first_300000_7percents = 0.0;
    this.next_300000_11percents = 0.0;
    this.first_500000_15percents = 0.0;
    this.next_500000_19percents = 0.0;
    this.next_1600000_21percents = 0.0;
    this.above_3200000_24percents = 0.0;

    if (temp > 300000) {
      this.first_300000_7percents = 0.07 * _300k;
      temp -= _300k;
      if (temp > _300k) {
        this.next_300000_11percents = 0.11 * _300k;
        temp -= _300k; //Remove 2nd 300,000
        if (temp > _500k) {
          this.first_500000_15percents = 0.15 * _500k;
          temp -= _500k; //Remove first 500,000
          if (temp > _500k) {
            this.next_500000_19percents = 0.19 * _500k;
            temp -= _500k; //Remove second 500,000
            if (temp > _1600k) {
              this.next_1600000_21percents = 0.21 * _1600k;
              temp -= _1600k; //Remove 1,600,000
              if (temp > 0.0) {
                this.above_3200000_24percents = 0.24 * temp;
              }
            } else {
              this.next_1600000_21percents = 0.21 * temp;
            }
          } else {
            this.next_500000_19percents = 0.19 * temp;
          }
        } else {
          this.first_500000_15percents = 0.15 * temp;
        }
      } else {
        this.next_300000_11percents = 0.11 * temp;
      }
    } else {
      this.first_300000_7percents = 0;
    }

    var minTaxPayablePerAnnum = 0 * this.chargeableIncome;

    this.taxPayablePerAnnum =
        this.first_300000_7percents +
        this.next_300000_11percents +
        this.first_500000_15percents +
        this.next_500000_19percents +
        this.next_1600000_21percents +
        this.above_3200000_24percents;

    this.NTP =
        this.taxPayablePerAnnum > minTaxPayablePerAnnum
            ? this.taxPayablePerAnnum
            : minTaxPayablePerAnnum;

    this.duty = this.getStampDuty(this.NTP);

    let TP = 0;
    TP  += 500 + this.duty + this.NTP;

    return {
        first300: this.first_300000_7percents,
        second300: this.next_300000_11percents,
        third500: this.first_500000_15percents,
        fourth500: this.next_500000_19percents,
        fift1600: this.next_1600000_21percents,
        above1600: this.above_3200000_24percents,
        totalChargeableIncome: this.chargeableIncome,
        totalConsolidatedRelief: this.relief,
        totalIncome: this.grossincome,
        totalTaxDue: this.NTP,
        totalTaxDeducted: 0.0,
        totalTaxPayable: TP,
        stampDuty: this.duty,
        developmentLevy: 500,
        witheldTax: 0,
        statutoryIncome: 0
    };
  }

    public calculateNewTaxLawIncomeToTaxComplete(annualChargeableIncome: number, relief: number): NewDirectTax {
        let remaining = annualChargeableIncome - relief;
        const result = {
            first2m: 0,
            first9m: 0,
            first13m: 0,
            first25m: 0,
            above50m: 0,
            totalChargeableIncome: Math.max(remaining, 0),
            totalConsolidatedRelief: relief,
            totalIncome: annualChargeableIncome,
            totalTaxDue: 0,
            totalTaxDeducted: 0,
            totalTaxPayable: 0,
            stampDuty: 0,
            developmentLevy: 500,
            witheldTax: 0,
            statutoryIncome: 0
        };

        if (remaining <= 840_000) {
            result.totalTaxDue = 0;
            result.totalTaxPayable = 500;
            return result;
        }

        remaining -= 800_000;

        const bands = [
            { limit: 2_200_000, rate: 0.15, key: "first2m" },
            { limit: 9_000_000, rate: 0.18, key: "first9m" },
            { limit: 13_000_000, rate: 0.21, key: "first13m" },
            { limit: 25_000_000, rate: 0.23, key: "first25m" },
            { limit: Infinity, rate: 0.25, key: "above50m" }
        ] as const;

        let totalTax = 0;

        for (const band of bands) {
            if (remaining <= 0) break;

            const taxable = Math.min(remaining, band.limit);
            const bandTax = taxable * band.rate;
            (result as any)[band.key] = bandTax;

            totalTax += bandTax;
            remaining -= taxable;
        }

        const duty = this.getStampDuty(totalTax);
        result.stampDuty = duty;
        let taxPayable = totalTax + duty + 500

        result.totalTaxDue = totalTax;
        result.totalTaxPayable = taxPayable;

        return result;
    }
    public calculateNewTaxLawIncomeToTax(annualChargeableIncome: number, relief:number): number {
        if (annualChargeableIncome - relief <= 840000) return 0;

        const bands = [
            { limit: 2200000, rate: 0.15 },
            { limit: 9000000, rate: 0.18 },
            { limit: 13000000, rate: 0.21 },
            { limit: 25000000, rate: 0.23 },
            { limit: Infinity, rate: 0.25 }
        ];

        let remaining = annualChargeableIncome - 800000 - relief;
        let tax = 0;

        for (const band of bands) {
            if (remaining <= 0) break;

            const taxable = Math.min(remaining, band.limit);
            tax += taxable * band.rate;
            remaining -= taxable;
        }

        return tax;
    }
    public reverseTaxToIncome(tax) {
        if (tax <= 0) return 840000; // No tax → max income in 0% bracket

        const bandLimits = [
            { maxTax: 330000, rate: 0.15, bandIncome: 2200000 },
            { maxTax: 1950000, rate: 0.18, bandIncome: 9000000 },
            { maxTax: 4680000, rate: 0.21, bandIncome: 13000000 },
            { maxTax: 10430000, rate: 0.23, bandIncome: 25000000 },
            { maxTax: Infinity, rate: 0.25, bandIncome: Infinity }
        ];

        let income = 800000; // base income before tax starts
        let remainingTax = tax;

        for (let i = 0; i < bandLimits.length; i++) {
            const { maxTax, rate, bandIncome } = bandLimits[i];
            const previousBandsTax = i === 0 ? 0 : bandLimits[i - 1].maxTax;

            if (tax > previousBandsTax) {
                const bandTaxLimit = maxTax - previousBandsTax;

                if (remainingTax >= bandTaxLimit) {
                    income += bandIncome;
                    remainingTax -= bandTaxLimit;
                } else {
                    const partialIncome = remainingTax / rate;
                    income += partialIncome;
                    return income;
                }
            }
        }
        return income;
    }
    public reverseTaxToIncomeComplete(tax: number): NewDirectTax {
        const result: NewDirectTax = {
            first2m: 0,
            first9m: 0,
            first13m: 0,
            first25m: 0,
            above50m: 0,
            totalChargeableIncome: 0,
            totalConsolidatedRelief: 0,
            totalIncome: 0,
            totalTaxDue: 0,
            totalTaxDeducted: 0,
            totalTaxPayable: 0,
            stampDuty: 0,
            developmentLevy: 500,
            witheldTax: 0,
            statutoryIncome: 0
        };

        if (tax <= 0) {
            result.totalChargeableIncome = 800_000;
            result.totalIncome = 800_000;
            result.totalTaxDue = 500; // development levy
            result.totalTaxPayable = 500;
            return result;
        }

        const bands = [
            { limit: 2_200_000, rate: 0.15, key: "first2m" },
            { limit: 9_000_000, rate: 0.18, key: "first9m" },
            { limit: 13_000_000, rate: 0.21, key: "first13m" },
            { limit: 25_000_000, rate: 0.23, key: "first25m" },
            { limit: Infinity, rate: 0.25, key: "above50m" }
        ] as const;

        const cumulativeTaxes: number[] = [];
        let cumulative = 0;
        for (const b of bands) {
            const bandTax = (b.limit === Infinity) ? Infinity : b.limit * b.rate;
            cumulative += bandTax;
            cumulativeTaxes.push(cumulative);
        }

        let remainingTax = tax;
        let income = 800_000; // base non-taxable
        for (let i = 0; i < bands.length; i++) {
            const band = bands[i];
            const prevCumulative = i === 0 ? 0 : cumulativeTaxes[i - 1];
            const maxBandTax = cumulativeTaxes[i] - prevCumulative;

            if (remainingTax >= maxBandTax) {
                (result as any)[band.key] = maxBandTax;
                income += band.limit;
                remainingTax -= maxBandTax;
            } else {
                const partialIncome = remainingTax / band.rate;
                (result as any)[band.key] = remainingTax;
                income += partialIncome;
                remainingTax = 0;
                break;
            }
        }

        result.totalChargeableIncome = income;
        result.totalIncome = income;

        const duty = this.getStampDuty(tax);
        result.stampDuty = duty;

        const totalTax = tax + duty + 500;
        result.totalTaxDue = totalTax;
        result.totalTaxPayable = totalTax;

        return result;
    }
    
    public getDeductionAllowance(deductionsDto: DeductionsDto): number {
        let deductablesPercent = 0;
        const { grossIncome, nhf, lap, nsitf, pension, nhis, rent } = deductionsDto;
        if (nhf != null) {
            deductablesPercent += Math.min(nhf, 0.05 * grossIncome);
        }
        if (lap != null) {
            deductablesPercent += Math.min(lap, 0.025 * grossIncome);
        }
        if (nsitf != null) {
            deductablesPercent += Math.min(nsitf, 0.01 * grossIncome);
        }
        if (pension != null) {
            deductablesPercent += Math.min(pension, 0.08 * grossIncome);
        }
        if (nhis != null) {
            deductablesPercent += Math.min(nhis, 0.025 * grossIncome);
        }
        if (rent != null) {
            const rentDeduction = Math.min(rent * 0.02, 500_000);
            deductablesPercent += rentDeduction;
        }
        return deductablesPercent;
    }

    public getStampDuty(amount: number): number {
        if (amount < 1000) return 0;

        const thresholds = [
            { limit: 10000, duty: 50 },
            { limit: 50000, duty: 100 },
            { limit: 100000, duty: 200 },
            { limit: 500000, duty: 500 },
            { limit: 1000000, duty: 1000 },
            { limit: Infinity, duty: 5000 }
        ];

        for (const t of thresholds) {
            if (amount <= t.limit) return t.duty;
        }
        return 0;
    }


  public getStatutoryIncome(earned:EarnedIncome,unearned:UnEarnedIncome ):number{
    return this.getEarnedIncome(earned) + this.getUnearnedIncome(unearned);
  }

  public getTotalIncome(earned:EarnedIncome, unearned:UnEarnedIncome,deductions:TaxDeduction):number{
    return (this.getEarnedIncome(earned) + unearned.royalty + unearned.rent) - this.getTaxDeduction(deductions);
  }
  getEarnedIncome(amount: EarnedIncome): number {
    return amount.trade + amount.employment + amount.consultation + amount.director + amount.profit;
  }

  getUnearnedIncome(amount: UnEarnedIncome): number {
    return amount.dividend + amount.interest + amount.royalty + amount.rent;
  }

    getTaxDeduction(amount: TaxDeduction): number {
        return amount.pension + amount.gratuities + amount.otherIncome + amount.bonus;
    }

    getTaxRelief(amount: TaxRelief): number {
        return amount.pension + amount.nhf + amount.nhis + amount.lap + amount.children + Math.min(amount.rent * 0.2, 500000);
    }

    getTaxWithheld(amount: TaxWithheld, unearned:UnEarnedIncome): number {
        return (amount.rent + amount.commission + amount.consultation + amount.directors + amount.contract + amount.others) + (0.1 * (unearned.interest + unearned.dividend));
    }

    getCRA(relief: TaxRelief, earned:EarnedIncome, unearned:UnEarnedIncome,deductions:TaxDeduction): number {
     return (0.01 *(this.getTotalIncome(earned,unearned,deductions) - this.getTaxRelief(relief))) > 200000 ? (0.01 * (this.getTotalIncome(earned,unearned,deductions) - this.getTaxRelief(relief)) + (0.2*this.getTotalIncome(earned,unearned,deductions))) : 200000 + (0.2*this.getTotalIncome(earned,unearned,deductions));
    }

    getReliefAllowaance(relief: TaxRelief, earned:EarnedIncome, unearned:UnEarnedIncome,deductions:TaxDeduction): number {
      return this.getCRA(relief, earned, unearned,deductions) + this.getTaxRelief(relief);
    }

    getChargeableIncome(earned:EarnedIncome, unearned:UnEarnedIncome,deductions:TaxDeduction,relief: TaxRelief): number {
        return this.getTotalIncome(earned,unearned,deductions) - this.getReliefAllowaance(relief, earned, unearned,deductions);
    }

    getNewTaxPayable(earned:EarnedIncome, unearned:UnEarnedIncome,relief:TaxRelief): NewDirectTax {
        var chargeableIncome = this.getStatutoryIncome(earned, unearned) - this.getTaxRelief(relief);
        var statutoryIncome = this.getStatutoryIncome(earned, unearned);
        let reliefs = this.getTaxRelief(relief);
        let results = this.calculateNewTaxLawIncomeToTaxComplete(statutoryIncome, reliefs);

        return {
            first2m: results.first2m,
            first9m: results.first9m,
            first13m: results.first13m,
            first25m: results.first25m,
            above50m: results.above50m,
            totalChargeableIncome: chargeableIncome,
            totalConsolidatedRelief: reliefs,
            totalIncome: statutoryIncome,
            totalTaxDue: results.totalTaxDue,
            totalTaxDeducted: 0.0,
            totalTaxPayable: results.totalTaxPayable,
            stampDuty: 0,
            developmentLevy: 500,
            witheldTax: 0,
            statutoryIncome: statutoryIncome
        };
    }
    getTaxPayable(withheld: TaxWithheld,earned:EarnedIncome, unearned:UnEarnedIncome,deductions:TaxDeduction,relief:TaxRelief): NewDirectTax {

      var chargeableIncome = this.getChargeableIncome(earned, unearned, deductions, relief);
      var totalRelief = this.getReliefAllowaance(relief, earned, unearned, deductions);
      var totalIncome = this.getTotalIncome(earned, unearned, deductions);
      var witheldTax = this.getTaxWithheld(withheld, unearned);
      var statutoryIncome = this.getStatutoryIncome(earned, unearned);
      var cra = this.getCRA(relief, earned, unearned, deductions);

      var _300k = 300000.0,
          _500k = 500000.0,
          _1600k = 1600000.0,
          _3200k = 1600000.0,
          TP = 0.0;

      this.first_300000_7percents = 0.0;
      this.next_300000_11percents = 0.0;
      this.first_500000_15percents = 0.0;
      this.next_500000_19percents = 0.0;
      this.next_1600000_21percents = 0.0;
      this.above_3200000_24percents = 0.0;

      if (chargeableIncome > 300000) {
        this.first_300000_7percents = 0.07 * _300k;
        chargeableIncome -= _300k;
        if (chargeableIncome > _300k) {
          this.next_300000_11percents = 0.11 * _300k;
          chargeableIncome -= _300k; //Remove 2nd 300,000
          if (chargeableIncome > _500k) {
            this.first_500000_15percents = 0.15 * _500k;
            chargeableIncome -= _500k; //Remove first 500,000
            if (chargeableIncome > _500k) {
              this.next_500000_19percents = 0.19 * _500k;
              chargeableIncome -= _500k; //Remove second 500,000
              if (chargeableIncome > _1600k) {
                this.next_1600000_21percents = 0.21 * _1600k;
                chargeableIncome -= _1600k; //Remove 1,600,000
                if (chargeableIncome > 0.0) {
                  this.above_3200000_24percents = 0.24 * chargeableIncome;
                }
              } else {
                this.next_1600000_21percents = 0.21 * chargeableIncome;
              }
            } else {
              this.next_500000_19percents = 0.19 * chargeableIncome;
            }
          } else {
            this.first_500000_15percents = 0.15 * chargeableIncome;
          }
        } else {
          this.next_300000_11percents = 0.11 * chargeableIncome;
        }
      } else {
        this.first_300000_7percents = 0.07 * chargeableIncome;
      }

        console.log(this.getNewTaxPayable(earned, unearned, relief));

      var minTaxPayablePerAnnum = 0;

      const taxPayablePerAnnum =
          this.first_300000_7percents +
          this.next_300000_11percents +
          this.first_500000_15percents +
          this.next_500000_19percents +
          this.next_1600000_21percents +
          this.above_3200000_24percents;

      var NTP =
          taxPayablePerAnnum > minTaxPayablePerAnnum
              ? taxPayablePerAnnum
              : minTaxPayablePerAnnum;

        TP = NTP;
      return {
          first300: this.first_300000_7percents,
          second300: this.next_300000_11percents,
          third500: this.first_500000_15percents,
          fourth500: this.next_500000_19percents,
          fift1600: this.next_1600000_21percents,
          above1600: this.above_3200000_24percents,
          totalChargeableIncome: chargeableIncome,
          totalConsolidatedRelief: totalRelief,
          totalIncome: totalIncome,
          totalTaxDue: NTP,
          totalTaxDeducted: 0.0,
          totalTaxPayable: TP - witheldTax,
          stampDuty: 0,
          developmentLevy: 500,
          witheldTax: witheldTax,
          statutoryIncome: statutoryIncome
      };
    }
}
